import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "album-dtm" }
const _hoisted_2 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_3 = {
  key: 1,
  class: "avatars"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapMarkerOutlineIcon = _resolveComponent("MapMarkerOutlineIcon")!
  const _component_NcAvatar = _resolveComponent("NcAvatar")!
  const _component_LinkIcon = _resolveComponent("LinkIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.album?.location)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MapMarkerOutlineIcon, {
            class: "icon",
            size: 18
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.album.location), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.album && (_ctx.album?.collaborators.length ?? 0 > 1))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_NcAvatar, {
            user: _ctx.utils.uid!,
            showUserStatus: false
          }, null, 8, ["user"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.album.collaborators, (c) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (c.type === 3)
                ? (_openBlock(), _createBlock(_component_NcAvatar, {
                    key: 0,
                    isNoUser: true
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_LinkIcon, { size: 20 })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_NcAvatar, {
                    key: c.id,
                    user: c.id,
                    showUserStatus: false
                  }, null, 8, ["user"]))
            ], 64))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}